export const BOL3_PRINT_MEDIA_STYLES = `
    @media print {
        @page {
            size: A4;
            margin: 0.3in 0;
        }
        * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
        }
        html, body {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: auto !important;
        }
        body {
            background: white !important;
            font-family: Arial, "Microsoft Yahei", sans-serif !important;
        }
        body > *:not(#bol3-print-container) {
            display: none !important;
        }
        #bol3-print-container {
            display: block !important;
            position: static !important;
            width: 100% !important;
            height: auto !important;
            left: auto !important;
            top: auto !important;
            overflow: visible !important;
            margin: 0 !important;
            padding: 0 !important;
        }
        .bol3-doc {
            max-width: 570pt !important;
            margin: 0 auto !important;
            padding: 0 6pt !important;
        }
        table {
            /* 必须保持 collapse：整张表的边框网格一次算出、全表取整一致；
               改成 separate 后每个单元格盒子各自取整，打印预览里同一条列线会 1px/2px 混杂 */
            border-collapse: collapse !important;
            border-spacing: 0 !important;
            page-break-inside: auto;
        }
        tr {
            page-break-inside: avoid;
        }
        /* 跨页不重复表头：thead 默认 display:table-header-group，浏览器会在每一页重画一遍。
           Totals 已并入 Loading 表末行，表格因此可能只为这一行溢出到次页，
           重复的表头会孤立地出现在次页顶部 */
        .bol3-table thead {
            display: table-row-group;
        }
        .bol3-page-break {
            page-break-after: always;
        }
    }
    @media screen {
        #bol3-print-container {
            position: absolute !important;
            left: -9999px !important;
            top: -9999px !important;
            width: 0 !important;
            height: 0 !important;
            overflow: hidden !important;
        }
    }
`;
